var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBreasts2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 59,
  fill: "none",
  viewBox: "0 0 25 59"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M1.61 1c1.68 4.648 4.82 9.587 7.08 12.046 4.97 5.408 14.98 10.876 15.3 18.593.36 8.707-8.52 13.056-8.52 13.056s-.08.65-.03 2.489c.1 3.549.4 6.697.31 10.816"
})));
export default SvgBreasts2;